/* MooMenn-owned accessibility helpers. No tracking, account or cross-store redirects. */
(() => {
  if (window.moomennAccessibilityReady) return;
  window.moomennAccessibilityReady = true;
  const labels = {
    de: (v) => `${v} Artikel`,
    en: (v, n) => `${v} ${n === 1 ? 'item' : 'items'}`,
    es: (v, n) => `${v} ${n === 1 ? 'artículo' : 'artículos'}`,
    fr: (v, n) => `${v} ${n === 1 ? 'article' : 'articles'}`,
    it: (v, n) => `${v} ${n === 1 ? 'articolo' : 'articoli'}`,
    nl: (v, n) => `${v} ${n === 1 ? 'artikel' : 'artikelen'}`
  };
  const update = (element) => {
    const text = element.textContent.trim();
    const match = text.match(/\d+/);
    if (!match) return;
    const language = document.documentElement.lang.slice(0, 2).toLowerCase();
    const value = match[0] + (text.includes('+') ? '+' : '');
    element.setAttribute('aria-label', (labels[language] || labels.en)(value, Number(match[0])));
  };
  const bind = (element) => {
    if (element.dataset.mmCountObserved) return;
    element.dataset.mmCountObserved = 'true';
    update(element);
    new MutationObserver(() => update(element)).observe(element, {childList: true, characterData: true, subtree: true});
  };
  // Retire only the confirmed dead Beige Polo product label; preserve review data.
  const retiredReviewId = '1041f1d4-37ef-44e5-9db5-e45a28954883';
  const retiredReviewCardSelector = '.jm-review-item[review-uuid]';
  const preventRetiredProductNavigation = (event) => {
    if (event.type !== 'click' && !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };
  const retireReviewProductLabel = (root) => {
    if (!document.body.classList.contains('judgeme_all_reviews')) return;
    const cards = new Set(root.querySelectorAll?.(retiredReviewCardSelector) || []);
    if (root.matches?.(retiredReviewCardSelector)) cards.add(root);
    const ancestor = root.closest?.(retiredReviewCardSelector);
    if (ancestor) cards.add(ancestor);
    cards.forEach((card) => {
      if (!card.closest('.jdgm-all-reviews-widget-v2025')) return;
      if (card.getAttribute('review-uuid') !== retiredReviewId) return;
      card.querySelectorAll('.jm-product-variant-card__product-link').forEach((control) => {
        control.removeAttribute('role');
        control.removeAttribute('tabindex');
        control.removeAttribute('aria-label');
        control.style.cursor = 'default';
        control.style.textDecoration = 'none';
        if (control.dataset.mmRetiredReviewProductAction) return;
        control.dataset.mmRetiredReviewProductAction = 'true';
        control.addEventListener('click', preventRetiredProductNavigation, true);
        control.addEventListener('keydown', preventRetiredProductNavigation, true);
      });
    });
  };
  const scan = (root) => {
    retireReviewProductLabel(root);
    if (root.matches?.('cart-count')) bind(root);
    root.querySelectorAll?.('cart-count').forEach(bind);
    const selector = 'a.jdgm-medal[aria-label]';
    const medals = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
    medals.forEach((link) => {
      const text = link.textContent.trim();
      const label = link.getAttribute('aria-label') || '';
      if (text && !label.includes(text)) link.setAttribute('aria-label', `${label} (${text})`);
    });
  };
  const initialize = () => {
    scan(document);
    new MutationObserver((records) => {
      records.forEach(({addedNodes}) => addedNodes.forEach((node) => {
        if (node instanceof Element) scan(node);
      }));
    }).observe(document.body, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
})();
